import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetchWithAuthorization from '../Apis/useFetchWithAuthorization';
import { AiFillDelete } from 'react-icons/ai';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SellerOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders]=useState([])
  const { data: order, loading: pending, error } = useFetchWithAuthorization(
    'https://campus-closet-server.vercel.app/api/seller/orders'
  );
  const { data:username, loading:usernameLoading, error:r } = useFetchWithAuthorization("https://campus-closet-server.vercel.app/profile");
  useEffect(()=>{
    setOrders(order)
  },[order])

  // Handle delete functionality
  const handleDelete = (oid) => {
    console.log(oid);
    // Display a confirmation dialog to the user
    if (window.confirm('Are you sure you want to delete this order?')) {
      fetch(`https://campus-closet-server.vercel.app/orders/${oid}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Item deleted successfully!'); // Handle the response data
          // Perform any additional actions after successful deletion
          toast.success('Order deleted successfully!', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          setOrders((prevOrders) => prevOrders.filter((order) => order.oid !== oid));
        })
        .catch((error) => {
          console.error(error); // Handle the error
          // Perform any error handling or display error messages
          toast.error('Error deleting the order. Please try again later.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        });
    }
  };

    // Handle the call functionality
    const handleCall = (phoneNumber) => {
      window.location.href = `tel:${phoneNumber}`;
    };
    // Handle the call functionality
  const handleWhatsApp = (phoneNumber, buyer, ordereditem) => {
        // Message to pre-fill
          const message = `Hello *${buyer}*,

          I hope you're doing well. This is *${username.user.name}*, the seller from Campus Closet. I noticed you ordered the *${ordereditem}* from our store. I wanted to confirm the details of your order and discuss any specific preferences or questions you might have.          
          Please feel free to share any additional information or requests regarding your order. We're here to ensure you have a great shopping experience with us.          
          Looking forward to hearing from you!
          
          Best regards,
          ${username.user.name}`;

          // Construct the WhatsApp link
          const whatsappURL = `https://wa.me/254${phoneNumber}?text=${encodeURIComponent(message)}`;
          window.open(whatsappURL);
  };

  if (pending) {
    return (
      <div style={{ height: `calc(100vh - 100px)` }} className="flex justify-center">
        Loading...
      </div>
    );
  }

  if (error && error === 'Unauthorized') {
    return (
      <div style={{ height: `calc(100vh - 100px)` }} className="flex justify-center">
        <div>
          <h1>Unauthorized Access</h1>
          <button
            onClick={() => navigate('/login')}
            className={`w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center`}
          >
            Login
          </button>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: `calc(100vh - 100px)` }}>
        Error occurred. Try again later: {error}
      </div>
    );
  }

  return (
    <div className="">
      <h1 className="text-2xl font-bold mb-4 text-center">Orders</h1>
      <table className="table-auto border border-yellow-500 mx-2 shadow-xl">
        <thead className="">
          <tr className="bg-slate-300">
            <th className="p-2 md:p-3 border border-yellow-500">Customer Name</th>
            <th className="p-2 md:p-3 border border-yellow-500">Phone Number</th>
            <th className="p-2 md:p-3 border border-yellow-500">Ordered Items</th>
            <th className="p-2 md:p-3 border border-yellow-500">Delivery Location</th>
            <th className="p-2 md:p-3 border border-yellow-500">Order Date</th>
            <th className="p-2 md:p-3 border border-yellow-500">Call</th> {/* Added call column */}
            <th className="p-2 md:p-3 border border-yellow-500">WhatsApp</th> {/* Added call column */}
            <th className="p-2 md:p-3 border border-yellow-500">Delete</th>
          </tr>
        </thead>
        <tbody>
          {orders?.length > 0 ? (
            orders.map((order) => (
              <tr key={order.oid}>
                <td className="border border-yellow-500 bg-blue-200 p-2 md:p-3 ">
                  {order?.full_name}
                </td>
                <td className="border border-yellow-500 bg-blue-200 p-2 md:p-3 ">
                  0{order?.phone_number}
                </td>
                <td className="border border-yellow-500 bg-blue-200 p-2 md:p-3 ">
                  {order?.product_name}
                </td>
                <td className="border border-yellow-500 bg-blue-200 p-2 md:p-3 ">
                  {order?.derivery_location}
                </td>
                <td className="border border-yellow-500 bg-blue-200 p-2 md:p-3 ">
                  {order?.order_date.slice(0, 10)}
                </td>
            
                <td className="border border-yellow-500 bg-blue-200 p-2 md:p-3 ">
                  <button
                    onClick={() => handleCall(order?.phone_number)}
                    className=" text-green-600  text-sm flex items-center px-2 cursor-pointer"
                  >
                  <span className="mr-2">
                      <FaPhone /> 
                    </span>
                  </button>
                </td>
                <td className="border border-yellow-500 bg-blue-200 p-2 md:p-3 ">
                  <button
                    onClick={() => handleWhatsApp(order?.phone_number, order?.full_name, order?.product_name)}
                    className=" text-green-600  text-sm flex items-center px-2 cursor-pointer"
                  >
                  <span className="mr-2">
                      <FaWhatsapp size={26}/> 
                    </span>
                  </button>
                </td>
                <td className="border border-yellow-500 bg-blue-200 p-2 md:p-3 ">
                  <button
                    onClick={() => handleDelete(order.oid)}
                    className="border text-red-600 border-gray-400 rounded-md text-sm flex items-center px-2 cursor-pointer hover:bg-red-100 shadow-xl"
                  >
                    <span className="mr-2">
                      <AiFillDelete />
                    </span>
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center p-10 font-bold">
                No orders found. Please come back later
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <ToastContainer />
    </div>
  );
};

export default SellerOrders;





// import React from 'react';
// import useFetchWithAuthorization from '../Components/useFetchWithAuthorization';

// const SellerOrders = () => {
//   const { data:orders, loading:pending, error } = useFetchWithAuthorization('https://campus-closet-server.vercel.app/api/seller/orders');
//   if (pending) {
//     return <div style={{ height: `calc(100vh - 100px)` }} className='flex justify-center'>Loading...</div>; // Display a loading state while fetching orders
//   }
//   if (error && error === "Unauthorized") {
//     return(
//     <div style={{ height: `calc(100vh - 100px)` }} className=" flex justify-center">
//       <div>
//         <h1>Unauthorized Access</h1>
//         <button className={`w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center`} >Login</button>
//       </div>
//   </div>)
//   }
//   if (error) {
//     return <div style={{ height: `calc(100vh - 100px)` }}>Error occured. Try again later: {error}</div>; // Display an error message if the fetching fails
//   }

//   return (
// <section style={{ minHeight: `calc(100vh - 100px)` }} className='bg-gray-400'>
//   {orders?.length > 0 ? ( 
//   <div className="container mx-auto mb-3">
//   <div className="flex justify-center items-center">
//     <div className="max-w-full overflow-x-auto">
//       <h1 className="text-2xl font-bold mb-4 text-center">Orders</h1>
//       <table className="table-auto border border-yellow-500 mx-2">
//         <thead className=''>
//           <tr className="bg-slate-300">
//             <th className="p-2 md:p-3 border border-yellow-500">Customer Name</th>
//             <th className="p-2 md:p-3 border border-yellow-500">Phone Number</th>
//             <th className="p-2 md:p-3 border border-yellow-500">Ordered Items</th>
//             <th className="p-2 md:p-3 border border-yellow-500">Delivery Location</th>
//             <th className="p-2 md:p-3 border border-yellow-500">Order Date</th>
//           </tr>
//         </thead>
//         <tbody>
//           {orders?.length > 0 ? (
//             orders.map((order) => (
//               <tr key={order.oid}>
//                 <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>{order?.full_name}</td>
//                 <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>{order?.phone_number}</td>
//                 <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>{order?.product_name}</td>
//                 <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>{order?.derivery_location}</td>
//                 <td className='border border-yellow-500 bg-blue-200 p-2 md:p-3 '>{order?.order_date.slice(0, 10)}</td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="5" className='text-center p-10 font-bold'>No orders found. please come back later</td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//     </div>
//   </div>):(
//     <div className=''>
//       <h1 className='text-center font-bold'>No Orders Found. Come back later</h1>
//     </div>
//   )}
//   </section>

//   );
// };

// export default SellerOrders;
